import { FC } from "react";
import { Button, Modal } from "antd";
import "./modal.scss";

interface CustomModalProps{
  visible: boolean;
  setVisible: (x: boolean) => void
}

const CustomModal: FC<CustomModalProps> = ({visible, setVisible}) => {

  return (
    <>
      <Modal
        wrapClassName="custom-action-modal"
        title={"Session Timeout"}
        centered
        visible={visible}
        footer={false}
      > 
        <>
            <p
              style={{
                fontSize: "14px",
                fontWeight: "normal",
                color: "#091e42",
              }}
            >
              {"Your account is logged out due to inactivity."}
            </p>
            <p>
                  <Button
                    type="primary"
                    size="large"
                    className="f16 w500 confirm-button"
                    onClick={() => setVisible(false)}
                  >
                    Close
                  </Button>
            </p>  
          </>
      </Modal>
    </>
  );
};

export default CustomModal;
